module.exports = __webpack_public_path__ + "img/Impacts to ESS-Impact interaction.ea9ee94c.svg";